import React from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { Button } from "@components/General/Button/button.component";
import AutocompleteHeader from "@components/Search/SearchAutocomplete/AutocompleteItem/autocompleteHeader.container";
import { RecentSearchesItem } from "@components/Search/SearchAutocomplete/RecentSearches/recentSearches.item.component";
import {
    clearRecentSearches,
    removeRecentSearchesItem,
} from "@components/Search/SearchAutocomplete/RecentSearches/recentSearches.source";
import { BaseTemplateProps } from "@components/Search/SearchAutocomplete/ResultsPanel/resultsPanel.templates";
import { RecentSearchesSourceType } from "@components/Search/SearchAutocomplete/autocompleteTypes";

import "./recentSearches.scss";

type RecentSearchesTemplateProps = BaseTemplateProps<RecentSearchesSourceType>;

const RecentSearchesTemplate = ({
    items,
    autocompleteState,
    autocompleteActions,
}: RecentSearchesTemplateProps) => {
    const { t } = useGranite();
    if (items.length === 0) return null;

    const handleOnRemoveRecentSearchItem = (label: string) => {
        removeRecentSearchesItem(label);
        autocompleteActions?.refresh();
    };

    const handleOnClearAllRecentSearchItem = () => {
        clearRecentSearches();
        autocompleteActions?.refresh();
    };

    return (
        <div>
            <AutocompleteHeader
                headerTitle={t("searchBox.panel.recentSearches.header.title")}
            >
                <Button
                    type={"button"}
                    color={"link"}
                    className={"py-2 px-0 text-primary"}
                    onClick={handleOnClearAllRecentSearchItem}
                >
                    {t("searchBox.panel.recentSearches.footer.button.clearAll")}
                </Button>
            </AutocompleteHeader>
            <ul className={"list-unstyled mb-0"}>
                {items.map(item => (
                    <li key={item.label}>
                        <RecentSearchesItem
                            item={item}
                            onRemoveRecentSearchItem={
                                handleOnRemoveRecentSearchItem
                            }
                            autocompleteState={autocompleteState}
                            autocompleteActions={autocompleteActions}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default RecentSearchesTemplate;
